/**
 * Discreet "an update is available" banner shown when a new bundle is
 * detected while the user is recording. The version-sync module
 * automatically applies the update once recording stops; the banner
 * is purely informational + offers a manual "Apply now" escape hatch
 * for users who want to abandon their trip and refresh immediately.
 *
 * Lives outside RecordPage because the same banner needs to appear
 * across the whole app shell — on the Map page or About page, the
 * banner still says "an update is available" but reload is safe
 * (no recording in progress) so version-sync would already have
 * reloaded silently. In practice the banner is only ever visible
 * during a recording.
 */
export function UpdateAvailableBanner() {
  const applyNow = () => {
    window.location.replace(window.location.href);
  };
  return (
    <div className="update-banner" role="status" aria-live="polite">
      <span className="update-banner-dot" aria-hidden="true" />
      <span className="update-banner-text">
        A newer version of joltstream is available. It'll apply
        automatically when you tap Stop.
      </span>
      <button
        type="button"
        className="update-banner-apply"
        onClick={applyNow}
      >
        Apply now
      </button>
    </div>
  );
}
